import React from "react";
import { Box, Text, Stack, HStack, Flex, Grid } from "@chakra-ui/react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "api/contentful/options";

interface Props {
  videoLink?: any;
  videoTitle?: any;
  videoDescription?: any;
}

const WelcomeCard: React.FC<Props> = ({videoLink, videoTitle, videoDescription }: Props) => {

  return (      
    <Box
      p={4}
      bg="gray.800"
      boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
      borderRadius="15px"
      position="relative"
      w="100%"
    >
      <Grid templateColumns='repeat(2)' gap={4}>
        <Stack direction="column" p={4}>
          <HStack>
            <Flex justifyContent="right">
              <iframe
                width="450"
                height="250"
                src={videoLink}
                title="Welcome to Charisma"
                allowFullScreen
              />
            </Flex>
            <Text p={4}>
              {videoDescription && documentToReactComponents(videoDescription, options)}
            </Text>
          </HStack>
        </Stack>
      </Grid>
    </Box>
  );
};

export default WelcomeCard;
